module.exports = __webpack_public_path__ + "img/IMG_3939.c067cf61.jpg";